<template>
  <div class="select" v-on-clickaway="closeSelect" :class="[ selectOpen ? 'active' : '' ]">
    <div class="select-header"
         :class="[{
         active : selected || currentOption !== null,
         open : selectOpen,
         disabled: disabled
         }]"
         @click="selectToggle">
      <input readonly :placeholder="myplaceholder" ref="myinput" type="text" class="select__list-search cursorPointer" v-model="search" v-on:click="refreshList">
      <div v-if="selected" class="form-placeholder">{{ myplaceholder }}</div>
      <span class="select__caret">
        <svg-icon type="icon-arrow-down"/>
      </span>
    </div>
    <div class="select__wrp" :class="[ selectOpen ? 'active' : '' ]">

      <div class="select__list">

        <div
          class="select__option"
          v-for="(option, index) in filteredItems"
          :key="index"
          :data-value="option.value"
          :class="{ selected : option.value === currentOption && currentOption.value }"
          @click="selectItem(option, option.value)"
        >
          <span class="icon-font" v-if="option.icon">
            <img :src="option.icon" alt="" class="icon">
          </span>

          <div class="select__option-title">
            {{ option.name }}
          </div>

        </div>
      </div>
    </div>

    <select hidden>
      <option
        v-for="(option, $index) in options"
        :key="$index"
        :value="option.value"
        :selected="option.value === currentOption && currentOption.value">
        {{ option.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
export default {
  mixins: [ clickaway ],
  name: 'SelectBoxTemp',
  components: {
  },
  data () {
    return {
      current: '',
      search: '',
      // title: 'Seçiniz',
      currentOption: null,
      selected: false,
      selectOpen: false,
    }
  },
  props: {
    myplaceholder: String,
    options: {
      type: Array,
      require: true
    },
    icon: Boolean,
    title: {
      type: String,
      default: 'Şehir Seçiniz'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectedValue: Number,
    name: ''
  },
  methods: {
    refreshList () {
      // console.log('refresh list')
    },
    selectItem (option, value) {
      // this.$refs.myinput.placeholder = option.name
      this.current = option.name
      this.currentOption = option
      this.selected = true
      this.selectOpen = false
      // this.$refs.myinput.value = 'heyyo'
      // sadece arama sayfalarında input u doldur (auto complete) yoksa tekrar tıklamada göstermesi için input u silmek gerekli -fakultesi-
     //   if(this.$route.fullPath ==='/' || this.$route.fullPath.includes('yurt-arama') || this.$route.fullPath.includes('-y-') || this.$route.fullPath.includes('sehirler') || this.$route.fullPath.includes('universiteler') ) {
        if(option.name != 'Sonuç bulunamadı!') {
         this.search = option.name
        }
     //  }
      this.$emit('onselect', this.currentOption)
    },
    selectToggle () {
      if (!this.disabled) {
        this.selectOpen = !this.selectOpen
      }
    },
    closeSelect () {
      this.selectOpen = false
    },
    getSelectedValue () {
      if (this.selectedValue) {
        const selectedItem = this.options.find((item) => item.id === this.selectedValue)
        this.currentOption = selectedItem || null
      } else {
        this.currentOption = null
      }
    },
    getFiltered (options) {
        return options.filter(item => {
        if (item.name) {
          return item.name.toLocaleUpperCase().indexOf(this.search.toLocaleUpperCase()) !== -1
        } else return ''
        })
    },    
  },
  computed: {
    filteredItems () {
      if (this.options) {
        let result = ''
        if (this.name === 'gender_name') {
          result = this.options
        } else {
          result = this.getFiltered(this.options)
        }
        const noresult = [{name:'Sonuç bulunamadı!'}]
        if (result.length) {
          return result
        } else {
          return noresult
        }
      } else {
        return null
      }
    }
  },
  watch: {
    options () {
      // this.selected = false
      this.getSelectedValue()
    }
  },
  mounted () {
    this.getSelectedValue()
    this.current = this.title
    if (!this.title) {
      this.current = 'Şehir Seçiniz'
    }
  },
  created() {
    if (!window.localStorage.getItem(this.name) || window.localStorage.getItem(this.name) === '' || window.localStorage.getItem(this.name) === 'null') {
              this.selected = false
    } else {
        this.selected = true
        this.search = window.localStorage.getItem(this.name)
          }
  },
  watch: {
    $route () {
      if (!window.localStorage.getItem(this.name) || window.localStorage.getItem(this.name) === '' || window.localStorage.getItem(this.name) === 'null') {
          this.selected = false
      } else {
        this.selected = true
        this.search = window.localStorage.getItem(this.name)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/selectbox";
</style>
